<script setup lang="ts">
import { toRefs, type PropType } from 'vue';
import { StatisticsKind, useSourceSelector } from '../..';

const props = defineProps({
  kind: {
    type: String as PropType<StatisticsKind>,
    required: true
  }
});

const { kind } = toRefs(props);

const { statisticsSourceView, viewsByKind } = useSourceSelector(kind);
</script>

<template>
  <div class="ma-3 d-flex justify-center">
    <v-btn-toggle
      v-model="statisticsSourceView"
      color="primary"
      density="compact"
      :mandatory="true">
      <v-btn
        v-for="view in viewsByKind"
        :key="view.value"
        :value="view.value">
        {{ view.name }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
